import { Nullable } from '@clearverify/types';

import { EmployerInfoFragment } from 'src/api';

import {
  EmployerCompanyInformationFormFields,
  EmployerCompanyInformationFormValues,
} from '../types';

export const getEmployerCompanyInformationInitialValues = (
  employer: Nullable<EmployerInfoFragment>,
): EmployerCompanyInformationFormValues => ({
  [EmployerCompanyInformationFormFields.displayName]: employer?.displayName,
  [EmployerCompanyInformationFormFields.industry]: {
    value: employer?.industry ?? '',
    label: employer?.industry ?? '',
  },
  [EmployerCompanyInformationFormFields.corporateStructure]: employer?.corporateStructure,
  [EmployerCompanyInformationFormFields.numberOfEmployees]: employer?.numberOfEmployees,
  [EmployerCompanyInformationFormFields.contactEmail]: employer?.contactEmail,
  [EmployerCompanyInformationFormFields.contactPhoneNumber]: employer?.contactPhoneNumber,
  [EmployerCompanyInformationFormFields.taxYearEndDate]: employer?.taxYearEndDate,
  [EmployerCompanyInformationFormFields.headquarters]: employer?.headquarters ?? null,
  [EmployerCompanyInformationFormFields.disclaimer]: employer?.disclaimer,
});
